import {AfterViewInit, Component, DoCheck, OnInit, ViewChild} from '@angular/core';
import {CommonModule, NgForOf, NgIf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {VisibilitySettingsService} from '../../services/visibility-settings.service';
import {WidgetService} from '../../services/widget.service';
import {WidgetConfigLookup} from '../../../common/models/widget-config.model';
import {LookupService} from '../../../common/service/lookup.service';
import {NgEventBus} from 'ng-event-bus';
import {MapToolsService} from '../../services/map-tools.service';
import {MapModeService} from '../../services/map-mode.service';
import {AppConfigService} from '../../../common/service/app-config.service';
import {CdkDrag, CdkDragHandle, DragRef, Point} from '@angular/cdk/drag-drop';
import {HelpLinkComponent} from '../../../help/help-link.component';
import {HELP_LINK_CONTENTS_BASE_URL} from '../../../common/constants';

@Component({
    selector: 'nlr-visibility-settings',
    imports: [CommonModule, FormsModule, CdkDrag, CdkDragHandle, HelpLinkComponent],
    providers: [CommonModule],
    templateUrl: './visibility-settings.component.html',
    styleUrl: './visibility-settings.component.scss'
})
export class VisibilitySettingsComponent implements OnInit, DoCheck {
    @ViewChild('widget')
    widgetElement: HTMLElement;

    title = 'VisibilitySettingsComponent';

    widgetId = 'visibilitySettings';

    widgetConfig: WidgetConfigLookup = {};

    visibilityOptions = [
        {value: true, displayValue: 'This page', toolTip: 'Apply visibility only on this plan'},
        {value: false, displayValue: 'Across ALL pages', toolTip: 'Apply visibility on all pages'}
    ];

    visibilitySelected = true;

    viewMode: string;

    widgetVisibleAtLastCheck: boolean;

    helpLinkUrl: string = HELP_LINK_CONTENTS_BASE_URL + 'visibility-settings-help.html';

    helpPageTitle: string = 'Apply Visibility Settings Tool';

    constructor(
        private appConfigService: AppConfigService,
        private lookupService: LookupService,
        private mapModeService: MapModeService,
        private mapToolsService: MapToolsService,
        private visibilitySettingsService: VisibilitySettingsService,
        private widgetService: WidgetService
    ) {}

    ngOnInit() {
        console.debug(`${this.title} - ngOnInit`);

        this.widgetConfig = this.lookupService.getLookups('widgetConfig').find((l: WidgetConfigLookup) => l.name === this.widgetId);

        this.visibilitySelected = this.visibilitySettingsService.applyVisibilityThisPageOnly;

        this.viewMode = this.mapModeService.viewMode;
    }

    ngDoCheck() {
        if (this.widgetElement && !this.widgetVisibleAtLastCheck) {
            this.widgetService.setupWidget(this.widgetId);
        }
        this.widgetVisibleAtLastCheck = !!this.widgetElement;
    }

    computeDragPosition = (userPointerPosition: Point, dragRef: DragRef, dimensions: DOMRect): Point => {
        return this.widgetService.computeDragPosition(userPointerPosition, dragRef, dimensions);
    };

    isWidgetActive() {
        return this.widgetService.isWidgetActive('VisibilitySettings');
    }

    getTooltip() {
        return this.mapToolsService.getTooltipWithShortcut('VISIBILITY_SETTINGS_WINDOW', 'Visibility Settings');
    }

    toggleWidgetVisibility() {
        this.widgetService.onClick('VisibilitySettings');
    }

    visibilityChanged() {
        this.visibilitySettingsService.applyVisibilityThisPageOnly = this.visibilitySelected;
    }

    applyVisibilityThisPageOnly() {
        return this.visibilitySettingsService.applyVisibilityThisPageOnly;
    }

    isDisabled() {
        return this.mapModeService.viewMode === this.appConfigService.getDesignProperties().VIEW_MODES.PRINT_PREVIEW_MODE;
    }
}
